import React from "react";

interface DataFieldProps {
  label: string;
  value: React.ReactNode;
  className?: string;
}

export function DataField({ label, value, className = "" }: DataFieldProps) {
  if (value === null || value === undefined || value === "") return null;

  return (
    <div
      className={`flex justify-between py-2 border-b border-gray-100 last:border-b-0 ${className}`}
    >
      <span className="text-sm text-gray-600 font-medium">{label}:</span>
      <span className="text-sm text-gray-900">{value}</span>
    </div>
  );
}
